const layoutTypes = {
	HORIZONTAL: 'horizontal',
	VERTICAL: 'vertical'
};

const layoutWidthTypes = {
	FLUID: 'fluid',
	BOXED: 'boxed',
	SCROLLABLE: 'scrollable'
};

const layoutModeTypes = {
	DARK: 'dark',
	LIGHT: 'light'
};

const topBarThemeTypes = {
	LIGHT: 'light',
	DARK: 'dark',
	COLORED: 'colored'
};

const leftBarThemeImageTypes = {
	NONE: 'none',
	IMG1: 'img1',
	IMG2: 'img2',
	IMG3: 'img3',
	IMG4: 'img4'
};

const leftSidebarTypes = {
	DEFAULT: 'default',
	COMPACT: 'compact',
	ICON: 'icon'
};

const leftSideBarThemeTypes = {
	LIGHT: 'light',
	COLORED: 'colored',
	DARK: 'dark',
	WINTER: 'winter',
	LADYLIP: 'ladylip',
	PLUMPLATE: 'plumplate',
	STRONGBLISS: 'strongbliss',
	GREATWHALE: 'greatwhale'
};

const taskBadges = {
	COMPLETED: 'bg-success',
	SENT: 'bg-success',
	'NOT SENT': 'bg-danger',
	'NOT STARTED': 'bg-danger',
	'IN PROGRESS': 'bg-warning',
	'NOT FILED': 'bg-danger',
	FILED: 'bg-success',
	'FILED WITH DUMMY DETAILS': 'bg-warning',
	'FILED WITH ACTUAL DETAILS': 'bg-success',
	'NOT DONE': 'bg-danger',
	'NOT SHARED': 'bg-danger',
	'SHARED DRAFT BILL': 'bg-warning',
	'SHARED ORIGINAL BILL': 'bg-success',
	'NOT COLLECTED': 'bg-danger',
	COLLECTED: 'bg-success',
	DONE: 'bg-success'
};

export {
	layoutTypes,
	layoutModeTypes,
	layoutWidthTypes,
	topBarThemeTypes,
	leftBarThemeImageTypes,
	leftSidebarTypes,
	leftSideBarThemeTypes,
	taskBadges
};
